export default __webpack_public_path__ + "static/media/cigar1.05f097fd.jpg";